import axios from "axios";

import { HttpStatusCode } from "axios";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import {
  notifyApiCallFailed,
  showNotification,
} from "./notifications/notificationsSlice";
import { logoutUser } from "./user/userThunks";

const formatErrorsHtml = (errors) => {
  const text = Array.isArray(errors) ? errors.join("\n") : errors;
  return text.replace(/(?:\r\n|\r|\n)/g, "<br />");
};

export const rtkErrorNotifications =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (isRejectedWithValue(action)) {
      const p = action.payload;

      if (p?._isAxiosError) {
        if (
          p.status === HttpStatusCode.Unauthorized ||
          p.status === HttpStatusCode.Forbidden
        ) {
          dispatch(logoutUser());
          return next(action);
        }

        if (
          [HttpStatusCode.UnprocessableEntity, HttpStatusCode.Conflict].includes(
            p.status,
          ) && p.errors
        ) {
          dispatch(
            showNotification({
              type: "error",
              message: "Error",
              description: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: formatErrorsHtml(p.errors),
                  }}
                />
              ),
            })
          );
          return next(action);
        }

        // The mail server refused a renewal email: the API says nothing was sent and what to
        // check before retrying, so show that (as plain text) instead of the generic failure.
        if (p.status === HttpStatusCode.BadGateway && p.errors) {
          dispatch(
            showNotification({
              type: "error",
              message: "Error",
              description: [p.errors].flat().join(" "),
            }),
          );
          return next(action);
        }

        dispatch(notifyApiCallFailed());
      }
    }
    return next(action);
  };

// Return a serializable payload
export function rejectAxiosError(e, api) {
  if (axios.isAxiosError(e)) {
    const status = e.response?.status;
    const errors = e.response?.data?.errors;

    return api.rejectWithValue({
      _isAxiosError: true,
      status,
      errors:
        typeof errors === "string" || Array.isArray(errors)
          ? errors
          : undefined,
    });
  }
  return api.rejectWithValue(null);
}
